import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { config } from '../config';
import { StripeContext } from './stripeContextDefinition';

interface StripeProviderProps {
  children: React.ReactNode;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  // Get the publishable key from runtime configuration
  const publishableKey = config.stripePublishableKey;

  if (!publishableKey) {
    console.warn('VITE_STRIPE_PUBLISHABLE_KEY is not set. Stripe features will not work.');
  }

  // Initialize Stripe
  const stripePromise = loadStripe(publishableKey || '');

  return (
    <StripeContext.Provider value={{ stripePromise }}>
      {children}
    </StripeContext.Provider>
  );
};
